import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue";
import { useRoute } from 'vue-router';
import { ref, computed, defineComponent, h, watch } from 'vue';
import { useLayoutStore } from '@/store';
export default /*#__PURE__*/_defineComponent({
  __name: 'KeepAliveRouterView',
  setup(__props) {
    const route = useRoute();
    const layoutStore = useLayoutStore();
    const keepAlive = ref();
    // 监听路由变化，根据当前路由名称查找对应的菜单项，并设置为当前菜单
    watch(() => route.name, newRouteName => {
      if (newRouteName && layoutStore.menuList && Array.isArray(layoutStore.menuList)) {
        try {
          // 遍历菜单列表，查找formRouterName等于当前路由名称的菜单项
          let targetMenu = null;
          function findMenuByRouterName(menuList) {
            for (const menu of menuList) {
              if (menu.formRouterName === newRouteName) {
                targetMenu = menu;
                return true;
              }
              if (menu.children && menu.children.length > 0) {
                if (findMenuByRouterName(menu.children)) {
                  return true;
                }
              }
            }
            return false;
          }
          findMenuByRouterName(layoutStore.menuList);
          // 如果找到对应的菜单项，设置为当前菜单
          if (targetMenu && targetMenu.menuId) {
            layoutStore.setCurrentMenu(targetMenu);
          }
        } catch (error) {
          console.error('Error in route watcher:', error);
        }
      }
    }, {
      immediate: true
    });
    function createComponent(name, component) {
      return defineComponent({
        name: name,
        render() {
          return component ? h(component) : null;
        }
      });
    }
    const keepAliveInclude = computed(() => {
      let tempList = [];
      layoutStore.tagList.filter(item => {
        const compomentName = item.compomentName;
        if (compomentName != null && tempList.indexOf(compomentName) === -1) {
          tempList.push(compomentName);
        }
      });
      return tempList;
    });
    const getRenderComponent = component => {
      const {
        name,
        query,
        fullPath
      } = route;
      if (route.meta.keepalive == null || !route.meta.keepalive) {
        return component;
      }
      let cacheKey = fullPath;
      let menuItem = layoutStore.currentMenu;
      let showName = route.meta?.title || route.name;
      let currentMenu;
      // 判断当前路由是否是菜单路由，如果是菜单的路由使用菜单的名字，对于在线表单和报表formRouterName为空，其他的路由菜单则通过formRouterName来判断
      if (menuItem != null && menuItem.menuId != null && (menuItem.formRouterName == null || menuItem.formRouterName === route.name)) {
        showName = menuItem.menuName;
        currentMenu = menuItem;
      }
      let tagItem = layoutStore.tagList.find(item => item.id === cacheKey);
      if (tagItem == null) {
        let tempComponent = createComponent(cacheKey, component);
        tagItem = {
          id: cacheKey,
          tagName: showName,
          routerName: route.name,
          compomentName: cacheKey,
          query: route.query,
          menuItem: currentMenu,
          component: tempComponent
        };
      } else if (tagItem.component == null || tagItem.component.render == null) {
        tagItem.component = createComponent(cacheKey, component);
      }
      if (tagItem.deleted !== true) {
        layoutStore.addTag(tagItem);
      }
      return tagItem.component;
    };
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(_component_router_view, null, {
        default: _withCtx(({
          Component
        }) => [_createVNode(_Transition, {
          name: "el-fade-in-linear",
          appear: true
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_KeepAlive, {
            ref_key: "keepAlive",
            ref: keepAlive,
            include: keepAliveInclude.value
          }, [(_openBlock(), _createBlock(_resolveDynamicComponent(getRenderComponent(Component))))], 1032, ["include"]))]),
          _: 2
        }, 1024)]),
        _: 1
      });
    };
  }
});